import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaQrcode } from 'react-icons/fa';
import { RoleLayout, RoleGrid, RoleTile } from './RoleShell';

const PorteriaDashboard = () => {
  const navigate = useNavigate();

  return (
    <RoleLayout
      title="Panel — Portería"
      subtitle="Herramientas de control de acceso para validar invitaciones y entradas."
      roleLabel="Rol: Portería"
    >
      <RoleGrid>
        <RoleTile
          icon={FaQrcode}
          label="Escanear invitaciones"
          description="Escanea y valida invitaciones de cortesía o lista."
          onClick={() => navigate('/escanear')}
        />
        <RoleTile
          icon={FaQrcode}
          label="Escanear entradas"
          description="Valida entradas pagadas y controla el acceso."
          onClick={() => navigate('/entradas/escanear')}
        />
      </RoleGrid>
    </RoleLayout>
  );
};

export default PorteriaDashboard;
